import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import LoadingCenter from '../../../Components/LoadingCenter';
import BackButtonRouter from '../../../Components/BackButtonRouter';
import InputRow from '../../../Components/InputRow';
import TextArea from '../../../Components/TextArea';
import DeleteButton from '../../../Components/DeleteButton';

import APIGet from '../../../API/APIGet';
import APIPost from '../../../API/APIPost';
import APIPut from '../../../API/APIPut';
import APIDelete from '../../../API/APIDelete';
import APIHelper from '../../../Helper/APIHelper';
import AuthHelper from '../../../Helper/AuthHelper';

import AppConfig from '../../../AppConfig';

export default class CompanyDetail extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			name: '',
			email: '',
			telephone: '',
			fax: '',
			address: '',
			creditDay: 30,
			taxId: '',
			note: '',
		};
	}

	async componentDidMount() {
		if (AuthHelper.hasRight('Staff', 'Reporter', 'Finance', 'Admin')) {
			let initUpdate = true;
			if (this.isUpdate()) {
				initUpdate = await this.initUpdate();
			}

			if (initUpdate) {
				this.setState({
					isLoading: false,
				});
			}
		} else {
			toast.warn('คุณไม่มีสิทธิ์ใช้งานในหน้านี้');
		}
	}

	initUpdate = async () => {
		const { companyId } = this.props.match.params;
		let requestCompany = APIGet('companies/' + companyId);
		requestCompany = await requestCompany;
		if (APIHelper.handleAPIResponse(this, requestCompany)) {
			const company = requestCompany.data;
			console.log('company: ', company);
			this.setState({
				name: company.name,
				email: company.email,
				telephone: company.telephone,
				fax: company.fax,
				address: company.address,
				creditDay: company.creditDay,
				taxId: company.taxId,
				note: company.note,
			});

			return true;
		} else if (requestCompany.status === 404) {
			toast.warning('ไม่พบข้อมูลดังกล่าว');
			return false;
		} else {
			toast.error('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
			return false;
		}
	};

	isUpdate = () => {
		const { companyId } = this.props.match.params;
		if (companyId) {
			return true;
		} else {
			return false;
		}
	};

	save = async () => {
		this.setState({
			isLoading: true,
		});

		const { companyId } = this.props.match.params;
		if (this.validateSaveState()) {
			let data = {
				name: this.state.name,
				email: this.state.email,
				telephone: this.state.telephone,
				fax: this.state.fax,
				address: this.state.address,
				creditDay: this.state.creditDay,
				taxId: this.state.taxId,
				note: this.state.note,
			};

			let request = null;
			if (this.isUpdate()) {
				request = await APIPut('companies/' + companyId, data);
			} else {
				request = await APIPost('companies', data);
			}

			if (APIHelper.handleAPIResponse(this, request)) {
				toast.success(this.isUpdate() ? 'แก้ไขเรียบร้อยแล้ว' : 'เพิ่มเรียบร้อยแล้ว');
				const result = request.data;
			} else {
				toast.error('เกิดปัญหาในการเพิ่มลูกค้า');
			}
		}

		this.setState({
			isLoading: false,
		});
	};

	validateSaveState = () => {
		const name = this.state.name.trim() !== '';
		if (!name) {
			toast.warn('กรุณาระบุชื่อ');
		}

		const telephone = this.state.telephone.trim() !== '';
		if (!telephone) {
			toast.warn('กรุณาระบุเบอร์โทรศัพท์');
		}

		const address = this.state.address.trim() !== '';
		if (!address) {
			toast.warn('กรุณาระบุที่อยู่');
		}

		const creditDay = !isNaN(this.state.creditDay);
		if (!creditDay) {
			toast.warn('กรุณาระบุ credit day โดยกรอกเป็นตัวเลขและจุดทศนิยมเท่านั้น (ไม่ต้องมี ,)');
		}

		return name && telephone && address && creditDay;
	};

	delete = async () => {
		const { companyId } = this.props.match.params;
		this.setState({
			isLoading: true,
		});

		let requestDelete = APIDelete('companies/' + companyId);
		requestDelete = await requestDelete;
		if (APIHelper.handleAPIResponse(this, requestDelete)) {
			toast.success('ลบเรียบร้อยแล้ว');
			this.props.history.replace(AppConfig.appPath + '/data/companies');
		} else {
			toast.error('ไม่สามารถลบได้ กรุณาลองใหม่อีกครั้ง');
			this.setState({
				isLoading: false,
			});
		}
	};

	onTextChange = (type, value) => {
		this.setState({
			[type]: value,
		});
	};

	handleSelectChange = (type, value) => {
		this.setState({
			[type]: value,
		});
	};

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		return (
			<div className="container">
				<BackButtonRouter />
				<div className="section">
					<div className="columns">
						<div className="column is-6">
							<h3 className="title is-3">{this.isUpdate() ? 'แก้ไขลูกค้า' : 'เพิ่มลูกค้า'}</h3>
						</div>
					</div>
					<div className="columns">
						<div className="column is-6">
							<InputRow
								title="ชื่อลูกค้า"
								labelSize="s"
								placeholder="ชื่อลูกค้า"
								keyProps="name"
								onInputChange={this.onTextChange}
								value={this.state.name}
								disabled={false}
								isMandatory={false}
							/>
						</div>
						<div className="column is-4">
							<InputRow
								title="tax"
								labelSize="s"
								placeholder="taxId"
								keyProps="taxId"
								onInputChange={this.onTextChange}
								value={this.state.taxId}
								disabled={false}
								isMandatory={false}
							/>
						</div>
						<div className="column is-2">
							<InputRow
								title="credit day"
								labelSize="s"
								placeholder="creditDay"
								keyProps="creditDay"
								onInputChange={this.onTextChange}
								value={this.state.creditDay}
								disabled={false}
								isMandatory={false}
							/>
						</div>
					</div>
					<div className="columns row">
						<div className="column is-4">
							<InputRow
								title="email"
								labelSize="s"
								placeholder="email"
								keyProps="email"
								onInputChange={this.onTextChange}
								value={this.state.email}
								disabled={false}
								isMandatory={false}
							/>
						</div>
						<div className="column is-4">
							<InputRow
								title="telephone"
								labelSize="s"
								placeholder="telephone"
								keyProps="telephone"
								onInputChange={this.onTextChange}
								value={this.state.telephone}
								disabled={false}
								isMandatory={false}
							/>
						</div>
						<div className="column is-4">
							<InputRow
								title="fax"
								labelSize="s"
								placeholder="fax"
								keyProps="fax"
								onInputChange={this.onTextChange}
								value={this.state.fax}
								disabled={false}
								isMandatory={false}
							/>
						</div>
					</div>
					<div className="columns row">
						<div className="column is-6">
							<TextArea
								title="Address"
								labelSize="s"
								keyProps="address"
								value={this.state.address}
								onInputChange={this.onTextChange}
								isMandatory={false}
							/>
						</div>
						<div className="column is-6">
							<TextArea
								title="Note"
								labelSize="s"
								keyProps="note"
								value={this.state.note}
								onInputChange={this.onTextChange}
								isMandatory={false}
							/>
						</div>
					</div>
					<div className="columns row">
						<div className="column is-6">
							{this.isUpdate() ? <DeleteButton label="ลบ" warningMessage="ยืนยันการลบ" onClick={this.delete} /> : null}
						</div>
						<div className="column is-6" style={{ textAlign: 'right', marginTop: 20 }}>
							<button className="button is-success" onClick={this.save}>
								บันทึก
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
